import type { FC } from 'react';

type RequestQuoteButtonProps = {
  onClick: () => void;
  className?: string;
};

const RequestQuoteButton: FC<RequestQuoteButtonProps> = ({
  onClick,
  className = '',
}) => (
  <button
    className={`site-header__cta ${className}`.trim()}
    onClick={onClick}
    type="button"
  >
    Request Quote
  </button>
);

export default RequestQuoteButton;
